module.exports = "/assets/data/c57b5ec8733cad89fa467dd511ba629e-HA7.data.json";